/**
 * Module to define Vue global filters, most of them emulating Vue pre-2.x
 * default filters.
 *
 * @module assets.js.filters
 */

/**
 * Export an array of filter objects, each containing a name that will be used
 * inside Vue templates to apply the filter to a given data, and a transformer
 * function accepting an initial value, optional additional arguments, and
 * returning the transformed data.
 *
 * @export
 */
export default [
  {
    name: 'crop',
    /**
     * Crop the given string, deleting characters past the first n wanted, eventually
     * suffixing it with the given string ending if the string was cropped.
     *
     * @function crop
     * @param {String} value The initial value to transform
     * @param {Number} n The number of characters to keep
     * @param {String} ending The string to suffix the original string with if it was cropped
     * @returns {String} The cropped string
     */
    filter(value, n, ending) {
      if (!value) return '';
      const rvalue = value.toString();
      if (rvalue.length <= n) return rvalue;

      return value.slice(0, n) + (ending || '');
    },
  },
  {
    name: 'capitalize',
    /**
     * Capitalize the string, uppercasing its first letter.
     *
     * @function capitalize
     * @param {String} value The initial value to transform.
     * @returns {String} The capitalied string
     */
    filter(value) {
      if (!value) return '';
      return value.toString().charAt(0).toUpperCase() + value.slice(1);
    },
  },
  {
    name: 'uppercase',
    /**
     * Uppercase the whole string.
     *
     * @function uppercase
     * @param {String} value The initial value to transform.
     * @returns {String} The uppercased string
     */
    filter(value) {
      if (!value) return '';
      return value.toString().toUpperCase();
    },
  },
  {
    name: 'lowercase',
    /**
     * Lowercase the whole string.
     *
     * @function lowercase
     * @param {String} value The initial value to transform.
     * @returns {String} The lowercased string
     */
    filter(value) {
      if (!value) return '';
      return value.toString().toLowerCase();
    },
  },
  {
    name: 'limit',
    /**
     * Keep only the first n elements in the given array.
     *
     * @function limit
     * @param {String} value The initial value to transform.
     * @param {String | Number} length The number of elements to keep.
     * @returns {Array} The uppercased string
     */
    filter(value, length) {
      const limitCount = parseInt(length, 10);
      if (limitCount <= 0) return value;

      return value.slice(0, limitCount);
    },
  },
  {
    name: 'telephoneFr',
    /**
     * Insert spaces between a given french telephone number
     *
     * @function telephoneFr
     * @param {String} value The initial value to transform.
     * @returns {String} The space phone number
     */
    filter(value) {
      const telRegex = /0\s*(\d)\s*(\d{2})\s*(\d{2})\s*(\d{2})\s*(\d{2})/;
      const tel = value.replace(telRegex, '(+33) $1 $2 $3 $4 $5');

      return tel;
    },
  },
];



// WEBPACK FOOTER //
// ./src/assets/js/filters.js